// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */
// @ts-nocheck - extra properties on window are not known

/**
 * Constants for the build version of the product. Each product specifies
 * build version in a different way.
 *  - Jira: window.BUILD_KEY
 *  - Confluence: window.__buildInfo.FRONTEND_VERSION
 */
export const PRODUCT_BUILD: any = window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION;
